import React, { useState } from "react";
import "./DropdownHeader.sass";

export function DropdownHeader({ text, dropItems }) {
  const [isOpen, setIsOpen] = useState()

  return (
    <>
      <div className="DropdownHeader">
        <button onClick={() => setIsOpen(!isOpen)}>
          {text}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
             data-is-open={isOpen}
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.197013 3.19701C0.459698 2.93433 0.885594 2.93433 1.14828 3.19701L5.53393 7.58266C5.78918 7.83792 6.21082 7.83792 6.46607 7.58266L10.8517 3.19701C11.1144 2.93433 11.5403 2.93433 11.803 3.19701C12.0657 3.4597 12.0657 3.88559 11.803 4.14828L7.41734 8.53393C6.63671 9.31455 5.36329 9.31455 4.58266 8.53393L0.197013 4.14828C-0.0656711 3.88559 -0.0656711 3.4597 0.197013 3.19701Z"
              fill="currentColor"
            />
          </svg>
        </button>

        <div data-is-open={isOpen} className="DropdownHeader__Items">
          {dropItems.map((item) => {
            return <button onClick={item.func}>{item.text}</button>;
          })}
        </div>
      </div>
    </>
  );
}
